<style lang="scss" scoped>
  $leftWidth: 0;
  .content-part {
    .content-left {
      width: $leftWidth;
    }

    .content-right {
      > h3 {
        left: $leftWidth;
      }

      left: $leftWidth;
    }

    .h2-title {
      padding-left: 0;
    }
  }

  .ui-left {
    max-height: 430px;
    height: auto;
    overflow: auto;

    .show-item {
      padding: 5px 0 5px 30px;
      position: relative;
      /*border-bottom: 1px solid #f1f1f1;*/

      .delete-remove {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 10px;
        color: red;
        display: none;
        cursor: pointer;
      }

      &:hover {
        background: #f1f1f1;

        .delete-remove {
          display: inline;
        }
      }
    }

    &.error {
      max-height: 200px;
    }

    &.normal {
      max-height: 200px;
    }

    .correct-color {
      color: #3DBE2E;
    }

    .error-color {
      color: #e00000;
    }
  }
</style>

<template>
  <div>
    <div class="content-part">
      <div class="content-right content-padding order-form" v-loading="loading">
        <h3>{{ title }}</h3>
        <div>
          <form-show-part :pageSetsItem="pageSets[5]" :currentTab="{}" v-if="currentOrder.id">
            <template slot="content">
              <el-row>
                <oms-col :value="currentOrder.orderNo" label="货主订单号"/>
                <oms-col :value="currentOrder.upstreamOrgName" label="货主"/>
                <oms-col label="订单货品类型" :isShow="true">
                  <dict dict-group="orderGoodsType" :dict-key=" '' + currentOrder.orderGoodsType"></dict>
                </oms-col>
                <oms-col label="业务类型" :value="currentOrder.bizType">
                  <dict :dict-group="'bspBizType'" :dict-key="currentOrder.bizType"></dict>
                </oms-col>
                <oms-col :label="`${$formatOrderType(orderType)}订单`" :value="currentOrder.orderThirdNo"/>
                <oms-col :label="$formatOrderType(orderType)" :value="currentOrder.downstreamOrgName"/>
                <oms-col :value="currentOrder.transportationMeans" label="物流方式">
                  <dict :dict-group="orderType === 0 ? 'transportationMeans' : 'outTransportMeans'"
                        :dict-key="currentOrder.transportationMeans"></dict>
                </oms-col>
                <oms-col label="下单时间" :value="currentOrder.createTime | minute"/>
              </el-row>
            </template>
          </form-show-part>
        </div>
        <div v-if="type==='0' && thirdOrderDetail && thirdOrderDetail.length">
          <form-show-part :pageSetsItem="pageSets[4]" :currentTab="{}">
            <template slot="content">
              <third-goods-list :goodsList="thirdOrderDetail"/>
            </template>
          </form-show-part>
        </div>

        <div v-if="type==='0'|| orderType === 1">
          <form-show-part :pageSetsItem="pageSets[0]" :currentTab="{}">
            <template slot="title-right">
            </template>
            <template slot="content">
              <div style="padding-left: 10px">
                <oms-upload-relation @change="(files) => changeFiles(files)" accept="xml" ref="uploadReload"
                                     uploadTip="只能上传xml文件"></oms-upload-relation>
              </div>
              <div class="review-code-btn" v-show="form.attachmentIdList.length">
                <el-button @click="reviewCode" size="mini" type="primary" :disabled="isDisabled">
                  解析文件
                </el-button>
              </div>
            </template>
          </form-show-part>
          <div v-show="fileList.length">
            <form-show-part :pageSetsItem="pageSets[1]" :currentTab="{}">
              <template slot="content">
                <file-list :file-list="fileList"/>
              </template>
            </form-show-part>
          </div>
        </div>


        <div v-if="!this.isHas && result && (result.errorCodeList.length || result.packageDtoList.length)">
          <div v-if="type === '0' || orderType === 1">
            <form-show-part :pageSetsItem="pageSets[2]" :currentTab="{}">
              <template slot="title-right">

              </template>
              <template slot="content">
                <el-row>
                  <el-col :span="12" style="padding-left: 10px" v-if="result.packageDtoList.length">
                    <div style="margin-top: 10px;margin-bottom: 10px">
                      【正常的追溯码】数量：{{result.packageDtoList.length}}
                    </div>
                    <ul class="show-list ui-left normal">
                      <li class="show-item" v-for="s in result.packageDtoList">
                        <el-tooltip :content="s.exceptionResultTitle" class="item" effect="dark"
                                    placement="right" v-if="s.exceptionResult != null ">
                          <span>{{ s.code }}</span>
                        </el-tooltip>
                        <span v-else="">{{ s.code }}</span>
                        <i class="el-icon-t-correct correct-color" v-if="s.status === 1"></i>
                        <i class="el-icon-t-error error-color" v-if="s.status === 2"></i>
                        <span @click="removeNumberItem(s, result.packageDtoList)" class="delete-remove">X</span>
                      </li>
                    </ul>
                  </el-col>
                  <el-col :span="12" style="padding-left: 10px" v-if="result.errorCodeList.length">
                    <div style="margin-top: 10px;margin-bottom: 10px">
                      【异常的追溯码】数量：{{result.errorCodeList.length}}
                    </div>
                    <ul class="show-list ui-left error">
                      <li class="show-item" v-for="s in result.errorCodeList">
                        <el-tooltip :content="s.exceptionResultTitle" class="item" effect="dark"
                                    placement="right" v-if="s.exceptionResult != null ">
                          <span>{{ s.code }}</span>
                        </el-tooltip>
                        <span v-else="">{{ s.code }}</span>
                        <i class="el-icon-t-correct correct-color" v-if="s.status === 1"></i>
                        <i class="el-icon-t-error error-color" v-if="s.status === 2"></i>
                        <span @click="removeNumberItem(s, result.errorCodeList)" class="delete-remove">X</span>
                      </li>
                    </ul>
                  </el-col>
                </el-row>

              </template>
            </form-show-part>
          </div>
        </div>

        <div v-show="orderType === 0 && type === '1'">
          <form-show-part :pageSetsItem="pageSets[3]" :currentTab="{}">
            <template slot="content">
              <receipt-detail :currentOrder="currentOrder" :isShowBaseInfo="false" ref="receipt"/>
            </template>
          </form-show-part>
        </div>
        <div v-if="orderType === 0" class="ml-10">
          <el-button :disabled="passLoading" @click="reviewPass" style="margin-top: 20px" type="success"
                     v-show="type === '0'">通过复核
          </el-button>
          <el-button :disabled="passLoading" @click="receivePass" style="margin-top: 20px" type="success"
                     v-show="type === '1'">
            确认收货
          </el-button>
          <el-button :disabled="passLoading" @click="returnOrder" style="margin-top: 20px" type="warning"
                     v-show="type === '1'">
            回退订单
          </el-button>
        </div>
        <div v-else class="ml-10">
          <el-button :disabled="passLoading" @click="reviewPass" style="margin-top: 20px" type="success">通过复核
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import FileList from './review-file-list';
  import receiptDetail from '@/components/order/detail/receipt-detail.vue';
  import {BSPOrder} from '@/resources';
  import thirdGoodsList from './third-goods-list';

  export default {
    props: {
      orderId: {
        type: String
      },
      defaultIndex: {
        type: Number
      },
      type: String
    },
    components: {FileList, receiptDetail, thirdGoodsList},
    data() {
      return {
        title: '复核订单',
        pageSets: [
          {name: '上传文件', key: 0},
          {name: '已解析文件', key: 1},
          {name: '解析结果', key: 2},
          {name: '收货信息', key: 3},
          {name: '上游发货信息', key: 4},
          {name: '订单信息', key: 5},
        ],
        doing: false,
        form: {
          attachmentIdList: []
        },
        fileList: [],
        result: null,
        loading: false,
        passLoading: false,
        currentOrder: {},
        thirdOrderDetail: null,
        isDisabled: false,
        isHas: true
      };
    },
    computed: {
      orderType() {
        return this.$route.meta.type;
      }
    },
    watch: {
      defaultIndex(val) {
        this.form.attachmentIdList = [];
        this.fileList = [];
        this.result = null;
        this.thirdOrderDetail = null;
        clearTimeout(this.timer);
        if (val !== 4) return;
        this.queryFiles();
        this.queryThirdOrderGoodsList();
      },
      type(val) {
        if (val === '0') {
          this.title = '收货';
        } else {
          if (this.orderType === 0) {
            this.title = '复核订单';
          } else {
            this.title = '复核追溯码';
          }
        }
      }
    },
    methods: {
      changeFiles(files) {
        this.isDisabled = files.some(s => !s.percentage);
        if (!files) {
          this.form.attachmentIdList = [];
        }
        this.form.attachmentIdList = files.map(m => m.attachmentId);
      },
      reviewCode() {
        if (!this.form.attachmentIdList.length) return '请上传文件';
        this.form.orderId = this.orderId;
        this.loading = true;
        this.$http.post('/bsp-review/file', this.form).then(res => {
          this.form.attachmentIdList = [];
          this.form.orderId = '';
          this.$refs.uploadReload.$refs.upload.clearFiles();
          this.queryFiles();
          this.loading = false;
        }).catch(e => {
          this.$notifyError(e, '解析失败');
          this.loading = false;
        });
      },
      queryFiles() {
        if (!this.orderId) return;
        this.loading = true;
        this.$http.get(`/bsp-review/${this.orderId}/file`).then(res => {
          this.fileList = res.data;
          this.isHas = res.data.some(s => s.attachmentDownloadTime === 0);
          if (this.isHas) {
            this.timer = setTimeout(() => {
              this.queryFiles();
            }, 200);
          } else {
            this.queryResult();
          }
        });
      },
      queryResult() {
        if (!this.orderId) return;
        this.$http.get(`/bsp-review/${this.orderId}/result`).then(res => {
          this.result = res.data;
          this.loading = false;
          this.$nextTick(() => {
            this.queryOrderDetail();
          });
        });
      },
      removeNumberItem(item, list) {
        this.$http.delete(`/bsp-review/${item.logId}`).then(res => {
          let index = list.indexOf(item);
          index !== -1 && list.splice(index, 1);
        });
      },
      reviewPass() {
        if (!this.orderId) return;
        this.passLoading = true;
        this.$http.post(`/bsp-review/${this.orderId}/complete`).then(res => {
          this.passLoading = false;
          this.$notify.success('复核通过');
          this.$emit('refresh');
        }).catch(e => {
          this.passLoading = false;
          this.$notifyError(e, '复核失败');
        });
      },
      receivePass() {
        if (!this.orderId) return;
        this.passLoading = true;
        this.$http.post(`/bsp-review/${this.orderId}/receipt`).then(res => {
          this.passLoading = false;
          this.$notify.success('收货完成');
          this.$emit('refresh');
        }).catch(e => {
          this.passLoading = false;
          this.$notifyError(e, '收货失败');
        });
      },
      returnOrder() {
        if (!this.orderId) return;
        this.passLoading = true;
        this.$http.post(`/bsp-review/${this.orderId}/receipt-cancel`).then(res => {
          this.passLoading = false;
          this.$notify.success('回退完成');
          this.$emit('refresh');
        }).catch(e => {
          this.passLoading = false;
          this.$notifyError(e, '回退失败');
        });
      },
      queryOrderDetail() {
        if (this.$refs.receipt) {
          this.$refs.receipt.goodsDetails = [];
        }
        this.currentOrder = {};
        if (!this.orderId) return false;
        BSPOrder.get(this.orderId).then(res => {
          this.currentOrder = res.data;
          this.$nextTick(() => {
            if (this.$refs.receipt) {
              this.$refs.receipt.goodsDetails = [];
              this.$refs.receipt.getGoodsDetails();
            }
          });
        });
      },
      queryThirdOrderGoodsList() {
        if (this.type !== '0') return;
        if (!this.orderId) return;
        this.$http.get(`bsp-order/${this.orderId}/third-order`).then(res => {
          this.thirdOrderDetail = res.data;
        });
      }
    }
  };
</script>
